import { render, staticRenderFns } from "./h5Video.vue?vue&type=template&id=22929050&scoped=true"
import script from "./h5Video.vue?vue&type=script&lang=js"
export * from "./h5Video.vue?vue&type=script&lang=js"
import style0 from "./h5Video.vue?vue&type=style&index=0&id=22929050&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22929050",
  null
  
)

export default component.exports